import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './task-simple.types';
import * as constants from './task-simple.constants';

export const storeTaskSimple = generateStoreResourceAction<types.ITaskSimple>(constants.STORE_TASK_SIMPLE);
export const clearTaskSimple = generateClearResourceAction(constants.CLEAR_TASK_SIMPLE);
